"use strict";

var LoggerInstance = require("js-logger").get("AccountApi");

var AbstractApi = require("./AbstractApi");

var StringConstants = require("../constants/StringConstants");

var ApiHelper = require("../shared/ApiHelper");

var queryParameterOverrides = require("../designer/Constants").QUERY_PARAMETER_OVERRIDES;

var AccountApi = class extends AbstractApi {
	changePassword(passwordChangeOptions) {
		return this.post({
			url: "/api/studioonlinechangepassword",
			data: passwordChangeOptions,
			reCAPTCHA: true,
			reCAPTCHAAction: StringConstants.ReCAPTCHAActions.PasswordReset
		});
	}

	changePrimaryContactInformation(primaryContactInformation) {
		ApiHelper.convertEmptyValuesToNull(primaryContactInformation);
		ApiHelper.convertObjectWithAllNullPropertiesToNull(primaryContactInformation);

		return this.post({
			url: "/api/changeprimarycontactinformation",
			data: primaryContactInformation
		});
	}

	changeSpouseInformation(spouseInformation) {
		ApiHelper.convertEmptyValuesToNull(spouseInformation);
		ApiHelper.convertObjectWithAllNullPropertiesToNull(spouseInformation);

		return this.post({
			url: "/api/changespouseInformation",
			data: spouseInformation
		});
	}

	childCommunicationsSaveCommunication(communication, pledgeId) {
		return this.post({
			url: `/api/createCorrespondence/${pledgeId}`,
			data: communication
		});
	}

	createAccount(accountData) {
		accountData.type = this.getAccountType(accountData);

		// Convert empty values to null so SE account validation does not fail
		ApiHelper.convertEmptyValuesToNull(accountData);

		return this.post({
			url: "/api/createaccount",
			data: accountData,
			reCAPTCHA: true,
			reCAPTCHAAction: StringConstants.ReCAPTCHAActions.Signup
		});
	}

	getAccountType(accountData) {
		if (accountData.organizationName || accountData.organizationType) {
			return "O";
		}

		return "I";
	}

	getDocumentTypes(documentTypeCode, options) {
		options = options || {};
		return this.get({
			queryString: ApiHelper.deleteUndefinedValues({
				"layoutId": window.layoutId,
				"documentsComponentId": options.documentsComponentId,
				"existingBreadcrumb": options.existingBreadcrumb,
				"documentTypeCode": documentTypeCode
			}),
			url: `/api/documents/partial`
		});
	}

	getReportParameters(options) {
		options = options || {};
		return this.get({
			queryString: ApiHelper.deleteUndefinedValues({
				"layoutId": window.layoutId,
				"reportParametersComponentId": options.reportParametersComponentId,
				"reportId": options.reportId
			}),
			url: `/api/reports/partial`
		});
	}

	getMediaValuesByAddress(options) {
		options = options || {};
		return this.get({
			queryString: ApiHelper.deleteUndefinedValues({
				"country": options.country,
				"currentMedia": options.currentMedia,
				"postalCode": options.postalCode,
			}, /*includeNulls*/true),
			url: "/api/mediabyaddress"
		});
	}

	mySubscriptionsGetSubscription(subscriptionId, options) {
		return this.get({
			queryString: ApiHelper.deleteUndefinedValues({
				"isEditing": options.isEditing,
				"layoutId": window.layoutId,
				"mySubscriptionComponentId": options.mySubscriptionComponentId,
				"subscriptionType": options.subscriptionType
			}),
			url: `/api/mysubscriptions/${subscriptionId}`
		});
	}

	myPledgesCancel(pledgeId, sponsorshipType) {
		return this.delete({
			url: `/api/mypledges/${pledgeId}?sponsorshipType=${sponsorshipType}`
		});
	}

	myPledgesEdit(pledgeId, myPledgesComponentId, editPledgeData, sponsorshipType) {
		return this.post({
			data: editPledgeData,
			url: `/api/mypledges/${pledgeId}?myPledgesComponentId=${myPledgesComponentId}&layoutId=${window.layoutId}&sponsorshipType=${sponsorshipType}`
		});
	}

	myPledgeGet(pledgeId, myPledgesComponentId, isEditing, sponsorshipType) {
		return this.get({
			url: `/api/mypledges/${pledgeId}?myPledgesComponentId=${myPledgesComponentId}&layoutId=${window.layoutId}&isEditing=${isEditing}&sponsorshipType=${sponsorshipType}`
		});
	}

	myPledgesMakeDonation(pledgeIds, sponsorshipType, shortComment) {
		return this.post({
			data: pledgeIds,
			queryString: ApiHelper.deleteUndefinedValues({
				sponsorshipType,
				shortComment
			}),
			url: "/api/mypledges/makedonations"
		});
	}

	myRelationshipPledgesMakeDonation(pledgeIds, relationshipType, relationshipRelatedType, shortComment) {
		return this.post({
			data: pledgeIds,
			queryString: ApiHelper.deleteUndefinedValues({
				relationshipType,
				relationshipRelatedType,
				shortComment
			}),
			url: "/api/myrelationshippledges/makedonations"
		});
	}

	myRecurringGetRecurring(recurringId, options) {
		return this.get({
			queryString: ApiHelper.deleteUndefinedValues({
				"donationId": options.donationId,
				"isEditing": options.isEditing,
				"layoutId": window.layoutId,
				"myRecurringComponentId": options.myRecurringComponentId,
				"usingDonations": options.usingDonations,
				"usingHeader": options.usingHeader,
				"usingPayment": options.usingPayment
			}),
			url: `/api/myrecurring/${recurringId}`
		});
	}

	myRecurringCancel(recurringId) {
		return this.delete({
			url: `/api/myrecurring/${recurringId}`
		});
	}

	myRecurringDeleteDonation(recurringId, donationId) {
		return this.delete({
			url: `/api/myrecurring/${recurringId}/donations/${donationId}`
		});
	}

	myRecurringEditDonation(recurringId, donationId, donationData, myRecurringComponentId) {
		return this.post({
			data: donationData,
			queryString: ApiHelper.deleteUndefinedValues({
				"layoutId": window.layoutId,
				"myRecurringComponentId": myRecurringComponentId
			}),
			url: `/api/myrecurring/${recurringId}/donations/${donationId}`
		});
	}

	myRecurringEditHeader(recurringId, recurringHeaderData, myRecurringComponentId) {
		return this.post({
			data: recurringHeaderData,
			queryString: ApiHelper.deleteUndefinedValues({
				"layoutId": window.layoutId,
				"myRecurringComponentId": myRecurringComponentId
			}),
			url: `/api/myrecurring/${recurringId}`
		});
	}

	myRecurringEditPayment(recurringId, paymentData, myRecurringComponentId) {
		return this.post({
			data: { payment: paymentData },
			queryString: ApiHelper.deleteUndefinedValues({
				"layoutId": window.layoutId,
				"myRecurringComponentId": myRecurringComponentId
			}),
			url: `/api/myrecurring/${recurringId}/payment`,
			reCAPTCHA: true,
			reCAPTCHAAction: StringConstants.ReCAPTCHAActions.PaymentAdd
		});
	}

	mySubscriptionsEdit(subscriptionId, subscriptionType, data, mySubscriptionComponentId) {
		return this.post({
			data,
			queryString: ApiHelper.deleteUndefinedValues({
				"layoutId": window.layoutId,
				"mySubscriptionComponentId": mySubscriptionComponentId,
				"subscriptionType": subscriptionType
			}),
			url: `/api/mysubscriptions/${subscriptionId}`
		});
	}

	standardizeAddress(addressData) {
		return this.post({
			data: addressData,
			url: `/api/standardizeaddress`
		})
	}

	downloadDocument(documentCode, documentFileName, shouldOpenInNewTab) {
		return this.download({
			documentCode,
			defaultFileName: documentFileName || `${documentCode}.txt`,
			queryString: ApiHelper.deleteUndefinedValues({
				documentCode
			}),
			shouldOpenInNewTab: shouldOpenInNewTab,
			url: "/api/documents/download"
		});
	}

	getAutoAddStateAndPostalCodesControlRecord() {
		return this.get({
			url: "/api/x01/ADDRSTDASP"
		});
	}

	otherAddressAdd(otherAddressesComponentId, addressData) {
		return this.post({
			data: addressData,
			url: `/api/otheraddresses?otherAddressesComponentId=${otherAddressesComponentId}&layoutId=${window.layoutId}&tangibleCode=${window.tangibleCode}`
		});
	}

	otherAddressDelete(addressId) {
		return this.delete({
			url: `/api/otheraddresses/${addressId}`
		});
	}

	otherAddressEdit(addressId, otherAddressesComponentId, addressData) {
		return this.post({
			data: addressData,
			url: `/api/otheraddresses/${addressId}?otherAddressesComponentId=${otherAddressesComponentId}&layoutId=${window.layoutId}&tangibleCode=${window.tangibleCode}`
		});
	}

	otherAddressesGet(addressId, otherAddressesComponentId, isEditing) {
		return this.get({
			url: `/api/otheraddresses/${addressId}?otherAddressesComponentId=${otherAddressesComponentId}&layoutId=${window.layoutId}&isEditing=${isEditing}&tangibleCode=${window.tangibleCode}`
		});
	}

	performLogin(credentials) {
		return this.post({
			url: "/api/studioonlineauthenticate",
			data: credentials,
			reCAPTCHA: true,
			reCAPTCHAAction: StringConstants.ReCAPTCHAActions.Login
		});
	}

	resetPassword (passwordResetOptions) {
		return this.post({
			url: "/api/studioonlineresetpassword",
			data: passwordResetOptions,
			reCAPTCHA: true,
			reCAPTCHAAction: StringConstants.ReCAPTCHAActions.PasswordReset
		});
	}

	saveAccountMedia (data) {
		ApiHelper.convertEmptyValuesToNull(data);
		ApiHelper.deleteUndefinedValues(data, /*includeNulls*/true);

		return this.post({
			data,
			url: "/api/saveaccountmedia"
		});
	}

	sendPasswordResetEmail (emailAddress) {
		return this.post({
			url: "/api/studioonlineforgotpassword",
			data: JSON.stringify({
				"emailAddress": emailAddress
			}),
			reCAPTCHA: true,
			reCAPTCHAAction: StringConstants.ReCAPTCHAActions.PasswordReset
		});
	}

	updateAccountCodes(accountCodes) {
		return this.post({
			url: "/api/accountcodes",
			data: JSON.stringify({
				"codes": accountCodes
			}),
			reCAPTCHA: true,
			reCAPTCHAAction: StringConstants.ReCAPTCHAActions.UpdateAccount
		});
	}

	createCommunication(communication) {
		return this.post({
			data: communication,
			url: "/api/communications"
		});
	}

	downloadReport(report, shouldOpenInNewTab) {
		return this.download({
			queryString: ApiHelper.deleteUndefinedValues(report),
			shouldOpenInNewTab: shouldOpenInNewTab,
			isReport: true,
			url: "/api/downloadreport"
		});
	}
};

module.exports = new AccountApi();
